/**
 * Cliente para comunicação com Google Apps Script API
 * Simples e direto - apenas fetch!
 */

// URL do Google Apps Script API
const GAS_API_URL = 'https://script.google.com/macros/s/AKfycbwGykkBeKn_W2rnGHmRSN7eZmUzp4rh-eQhtu9sr9eQ_sZttFc-pc2iLonZQrPTXyn1Dw/exec';

/**
 * Helper para fazer chamadas à API
 */
async function callAPI(action, params = {}) {
  try {
    const url = new URL(GAS_API_URL);
    url.searchParams.append('action', action);
    
    // Adiciona outros parâmetros
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
      }
    });

    
    const response = await fetch(url.toString(), {
      method: 'GET',
      redirect: 'follow'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error);
    }

    return data;
    
  } catch (error) {
    console.error(`❌ Erro na API (${action}):`, error);
    throw error;
  }
}

/**
 * Busca eventos ativos
 */
export async function getActiveEvents() {
  const response = await callAPI('getActiveEvents');
  return response.data || [];
}

/**
 * Busca detalhes de um evento específico
 */
export async function getEvent(eventSlug) {
  const response = await callAPI('getEvent', { eventSlug });
  return response.data || response.event || null;
}

/**
 * Busca dados de uma planilha (lotes, pedidos, etc)
 */
export async function getSpreadsheetData(sheetName, eventId = null) {
  const params = { sheetName };
  if (eventId) {
    params.eventId = eventId;
  }
  
  const response = await callAPI('getSpreadsheetData', params);
  return response.data || [];
}

/**
 * Salva um pedido
 */
export async function saveOrder(orderData) {
  try {
    const url = GAS_API_URL;
    
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'saveOrder',
        data: JSON.stringify(orderData)
      }),
      redirect: 'follow'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error);
    }

    return data;
    
  } catch (error) {
    console.error('❌ Erro ao salvar pedido:', error);
    throw error;
  }
}

/**
 * Gera QR Code PIX
 */
export async function generatePixQRCode(pixData) {
  const response = await callAPI('generatePixQRCode', { pixData });
  return response.qrCode;
}

/**
 * Faz upload de arquivo para o Drive
 */
export async function uploadFile(base64Data, eventId = null, nomeComprador = null) {
  try {
    const url = GAS_API_URL;
    
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'uploadFile',
        data: JSON.stringify({
          data: base64Data,
          eventId: eventId,
          nomeComprador: nomeComprador
        })
      }),
      redirect: 'follow'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error);
    }

    return data;
    
  } catch (error) {
    console.error('❌ Erro no upload:', error);
    throw error;
  }
}

/**
 * Envia email
 */
export async function sendEmail(emailData) {
  try {
    const url = GAS_API_URL;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'sendEmail',
        data: JSON.stringify(emailData)
      }),
      redirect: 'follow'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error);
    }

    return data;
    
  } catch (error) {
    throw error;
  }
}

/**
 * Solicita token para edição de pedido
 */
export async function requestEditToken(data) {
  const response = await callAPI('requestEditToken', data);
  return response;
}

/**
 * Verifica token de edição
 */
export async function verifyEditToken(data) {
  const response = await callAPI('verifyEditToken', data);
  return response;
}

/**
 * Busca ingressos de um pedido
 */
export async function getOrderTickets(orderNumber, eventId = null) {
  const params = { orderNumber };
  if (eventId) params.eventId = eventId;
  const response = await callAPI('getOrderTickets', params);
  return response;
}

/**
 * Atualiza dados de um ingresso
 */
export async function updateTicket(data) {
  try {
    const url = GAS_API_URL;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'updateTicket',
        data: JSON.stringify(data)
      }),
      redirect: 'follow'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data_result = await response.json();
    
    if (data_result.error) {
      throw new Error(data_result.error);
    }

    return data_result;
    
  } catch (error) {
    throw error;
  }
}

// Export default para compatibilidade
export default {
  getActiveEvents,
  getEvent,
  getSpreadsheetData,
  saveOrder,
  uploadFile,
  generatePixQRCode,
  sendEmail,
  requestEditToken,
  verifyEditToken,
  getOrderTickets,
  updateTicket
};
